import React from "react";
import ListItemButton from "@mui/material/ListItemButton";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import ListSubheader from "@mui/material/ListSubheader";
import DashboardIcon from "@mui/icons-material/Dashboard";
import PeopleIcon from "@mui/icons-material/People";
import LayersIcon from "@mui/icons-material/Layers";
import AssignmentIcon from "@mui/icons-material/Assignment";
import SupervisedUserCircleIcon from '@mui/icons-material/SupervisedUserCircle';
import {Link as RouterLink} from "react-router-dom"

export const mainListItems = (
    <React.Fragment>
        <ListItemButton component={RouterLink} to={"/dashboard"}>
            <ListItemIcon>
                <DashboardIcon/>
            </ListItemIcon>
            <ListItemText primary="Dashboard"/>
        </ListItemButton>
        <ListItemButton component={RouterLink} to={"/dashboard/evv"}>
            <ListItemIcon>
                <LayersIcon/>
            </ListItemIcon>
            <ListItemText primary="Missed Evvs"/>
        </ListItemButton>
        <ListItemButton component={RouterLink} to={"/dashboard/employees"}>
            <ListItemIcon>
                <PeopleIcon/>
            </ListItemIcon>
            <ListItemText primary="Employees"/>
        </ListItemButton>
        <ListItemButton component={RouterLink} to={"/dashboard/staff"}>
            <ListItemIcon>
                <SupervisedUserCircleIcon/>
            </ListItemIcon>
            <ListItemText primary="Staff"/>
        </ListItemButton>
    </React.Fragment>
);

export const secondaryListItems = (
    <React.Fragment>
        <ListSubheader component="div" inset>
            By year
        </ListSubheader>
        <ListItemButton>
            <ListItemIcon>
                <AssignmentIcon/>
            </ListItemIcon>
            <ListItemText primary="Year 2021"/>
        </ListItemButton>
        <ListItemButton>
            <ListItemIcon>
                <AssignmentIcon/>
            </ListItemIcon>
            <ListItemText primary="Year 2020"/>
        </ListItemButton>
        <ListItemButton>
            <ListItemIcon>
                <AssignmentIcon/>
            </ListItemIcon>
            <ListItemText primary="Year 2019"/>
        </ListItemButton>
    </React.Fragment>
);
